import React from 'react';
import { observer } from 'mobx-react';
import { OnboardingWrapper } from '@seedlang/hoc';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Backdrop from 'components/backdrop';
import { Theme } from '@seedlang/constants';
import { fixedCenter } from '@seedlang/style_mixins';
import { AppUI } from '@seedlang/state';
import { computed } from 'mobx';
import { isPresent } from '@seedlang/utils/src';
import AnimatedProgressBar from 'components/animated_progress_bar';
import DesktopOnly from 'utils/desktop_only';
import { Outlet } from 'react-router-dom';

const Wrapper = styled.div`
  ${fixedCenter()}
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: ${props => props.background};
  overflow-y: auto;
  overflow-x: hidden;
  padding: 60px 0;
  box-sizing: border-box;
  z-index: ${Theme.z.foreground};
  .title {
    margin-bottom: 20px;
    text-align: center;
  }
  .onboarding-spinner {
    position: absolute;
    top: 0;
    z-index: 999;
  }
  @media only screen and (max-height: 700px) {
    padding: 10px 0;
  }
  @media only screen and (max-width : 649px) {
    padding: 0;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: fit-content;
  background: ${props => props.background};
  border-radius: ${props => props.isMobile ? 0 : '20px'};
  max-width: ${props => props.isMobile ? '100%' : '500px'};
  width: ${props => props.isMobile ? '100%' : 'auto'};
  width: 100%;
  z-index: 4;
  padding: 10px;
  min-height: ${props => props.isMobile ? '100%' : 0};
  box-sizing: border-box;
  @media only screen and (max-width : 649px) {
    padding: 0;
  }

  @media only screen and (max-height: 700px) {
    margin: ${props => props.isMobile ? 0 : '10px auto'};
  }
`;

const OverflowInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 0;
  padding: ${props => props.padding};
  overflow: visible;
  box-sizing: border-box;
`;

const ChildrenWrapper = styled.div`
  margin-top: 12px;
  min-height: 0;
  width: 100%;
  overflow: visible;
  -webkit-overflow-scrolling: touch;
  padding: 0 10px;
  box-sizing: border-box;
`;

const ProgressBarWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
`;

@observer
class OnboardingSeedlang extends React.Component {

  constructor(props) {
    super(props);
    AppUI.setUpdatedDeviceLanguageId(this.props.params?.languageId);
  }

  @computed get currentRoute() {
    const routes = this.props.routes || [];
    return AppUI.routeStore.routeName || routes[routes.length - 1]?.name;
  }

  @computed get currentStep() {
    return this.props.onboardingSteps.find(item => item.route === this.currentRoute);
  }

  render() {
    return (
      <Wrapper
        background='#044067'
      >
        <DesktopOnly>
          <Backdrop
            percentageComplete={(this.currentIndex / 3) * 20}
          />
        </DesktopOnly>
        <InnerWrapper
          className='onboarding'
          isMobile={AppUI.layout.isMobile}
          background='#fff'
        >
          <OverflowInner
            isMobile={AppUI.layout.isMobile}
            padding={AppUI.layout.isMobile ? '30px 20px' : '20px 10px'}
          >
            {
              isPresent(this.currentStep) && this.props.params?.languageId &&
                <ProgressBarWrapper>
                  <AnimatedProgressBar
                    backgroundHeight={20}
                    progressHeight={20}
                    progressBarWidth={440}
                    borderTopRightRadius='10px'
                    borderTopLeftRadius='10px'
                    borderBottomRightRadius='10px'
                    borderBottomLeftRadius='10px'
                    background='#CCC'
                    total={this.props.onboardingSteps.length + 1}
                    current={this.currentStep['stepNumber']}
                  />
                </ProgressBarWrapper>
            }
            <ChildrenWrapper>
              <Outlet />
            </ChildrenWrapper>
          </OverflowInner>
        </InnerWrapper>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(OnboardingWrapper(OnboardingSeedlang));
